import React from "react";
import { ArrowRight, Badge, Button } from "@opendate-app/setlist";

import { htmlContentStyle } from "./Actions/EmailPreviewTab";
import TemplateHTMLPreview from "../BeefreeTemplates/TemplateHTMLPreview";

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 12,
};

const headerStyle = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
};

const boxStyle = {
  border: "1px solid var(--sl-border-secondary)",
  borderRadius: 8,
  height: "50vh",
  padding: 16,
  overflow: "auto",
};

export const editorPath = (action) => `/teams/${action.team_id}/campaigns/${action.campaign_id}/campaign_actions/${action.id}`;

const EmailPreview = ({
  action,
}) => {
  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <Badge color="brand">Email 1</Badge>
        <Button size="sm" as="a" href={editorPath(action)} trailingIcon={ArrowRight}>Go to editor</Button>
      </div>
      <div style={{ fontSize: 14 }}>
        <b>Subject: </b>{action.subject}
      </div>
      <div style={boxStyle}>
        <TemplateHTMLPreview
          htmlContent={action.renderable_body}
          style={htmlContentStyle}
          disableLinks
        />
      </div>
    </div>
  );
};

export default EmailPreview;
